import { objectEach } from './object';
import { isArray, isBoolean, isDate, isNumber, isString, isUndefined } from './type';
export const qsParse = (queryString) => {
    const params = new URLSearchParams(queryString);
    const result = {};
    for (const [key, val] of params.entries()) {
        if (isUndefined(result[key])) {
            result[key] = val;
            continue;
        }
        if (isArray(result[key])) {
            continue;
        }
        result[key] = params.getAll(key);
    }
    return result;
};
const defaultReplacer = (val) => {
    if (isString(val))
        return val;
    if (isNumber(val))
        return String(val);
    if (isBoolean(val))
        return val === true ? 'true' : 'false';
    if (isDate(val))
        return val.toISOString();
    return null;
};
export const qsStringify = (query, replacer = defaultReplacer) => {
    const params = new URLSearchParams();
    objectEach(query, (val, key) => {
        if (isArray(val)) {
            val.forEach((i) => {
                const replaced = replacer(i);
                if (replaced === null)
                    return;
                params.append(key, replaced);
            });
        }
        else {
            const replaced = replacer(val);
            if (replaced === null)
                return;
            params.set(key, replaced);
        }
    });
    return params.toString();
};
